import type React from "react";

import GoogleAuth from "../../../components/auth/google-auth/GoogleAuth";
import LoginForm from "../../../components/auth/login-form/LoginForm";
import { Separator } from "../../../components/ui/separator";

const Login: React.FC = () => {
  return (
    <div className='flex min-h-screen items-center justify-center bg-muted/50 px-4'>
      <div className='w-full max-w-md space-y-6'>
        <LoginForm />

        <div className='relative'>
          <div className='absolute inset-0 flex items-center'>
            <Separator className='w-full' />
          </div>
          <div className='relative flex justify-center text-xs uppercase'>
            <span className='bg-background px-2 text-muted-foreground'>Or continue with</span>
          </div>
        </div>

        <GoogleAuth />
      </div>
    </div>
  );
};

export default Login;
